import { render } from "./SiderLayout.vue?vue&type=template&id=39ef3f8f&scoped=true"
import script from "./SiderLayout.vue?vue&type=script&lang=js"
export * from "./SiderLayout.vue?vue&type=script&lang=js"

import "./SiderLayout.vue?vue&type=style&index=0&id=39ef3f8f&lang=less&scoped=true"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ef3f8f"]])

export default __exports__